import Vue from "vue";
import Component from "vue-class-component";
import {PracticeKind, PracticesClient} from "@/api-client";
import {ls} from "@/CultureService";

const practiceKindMap: { [id: string]: string; } = {
    [PracticeKind.Educational]: ls.Documents_Practices_PracticeKind_Educational,
    [PracticeKind.Work]: ls.Documents_Practices_PracticeKind_Work
};

@Component
export default class PracticeDetailsContentBase extends Vue {
    translatePracticeKind(kind: PracticeKind): string {
        return practiceKindMap[kind];
    }
}